import { render, staticRenderFns } from "./WRankSelect.vue?vue&type=template&id=fb182b3e&scoped=true&"
import script from "./WRankSelect.vue?vue&type=script&setup=true&lang=js&"
export * from "./WRankSelect.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb182b3e",
  null
  
)

export default component.exports